import React from "react";
import myImage from "../img/about/myself.jpg";

import awards_2019_dice from "../img/awards/2019-dice.jpg";
import awards_2018_dachshund from "../img/awards/2018-dachshund.jpg";
import activity_youtube_thumbnail from "../img/about/activity-youtube-thumbnail.png";
import activity_coding_hero from "../img/about/activity-coding-hero.png";

import PairReview from "./pair-review.jsx";

class About extends React.Component {
  constructor() {
    super();
  }

  render() {
    return (
      <section id="about" className="about-mf sect-pt4 route">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="title-box text-center">
                <h3 className="title-a">About</h3>
                <div className="line-mf"></div>
              </div>
            </div>
          </div>
          <article class="card-resume-item">
            <div class="section-title">
              <span>안녕하세요 😀</span>
            </div>

            <div class="section-items-group">
              <div class="card-resume-detail-item">
                <div class="card-text card-period">간단 소개</div>
                <div class="card-body">
                  <h4 class="card-title">협업 자신있는 프론트엔드 개발자</h4>
                  <p class="card-text">
                    React, Nuxt로 개발 가능한 프론트엔드 개발자 김선미입니다.
                    꾸준한 프로젝트 경험으로 개발 문화에 익숙하며 팀장 경험을
                    통해 기획 및 문서 작성도 자신있습니다. 기술이 교육에
                    적용되는 사례에 관심이 많고, 그 세상에 이바지하고 싶습니다.
                  </p>
                </div>
              </div>
              <div class="card-resume-detail-item">
                <div class="card-text card-period">Q n A</div>
                <div class="card-body">
                  <h4 class="card-title">Q. IT, 교육에 관심이 많으시나요?</h4>
                  <p class="card-text">
                    저는 교육 개혁에 진심이었고, 공부는 억지로 하면 안된다고
                    생각했습니다. 그래서 대학교에 가서도, 무작정 외우는 것이
                    아니라 "원리"를 이해하고, 그것을 "도식화 및 일반화"해서,
                    "공유하는" 나만의 공부 방식을 찾아갔습니다. &nbsp;
                    <a
                      class="href-highlight-orange"
                      href="https://kr-ddubbu.tistory.com/20?category=932301"
                    >
                      [더보기]
                    </a>
                  </p>
                  <br />
                  <h4 class="card-title">
                    Q. 주변분들이 선미님을 어떻게 평가하나요?
                  </h4>
                  <p class="card-text description">
                    아래는, 코드스테이츠 교육 중에 만났던 페어분들의
                    피드백입니다.
                    <br />
                    개발에 &nbsp;<span>열정적</span>으로 임하는 모습, &nbsp;
                    <span>빠른 습듭력</span> 그리고 &nbsp;<span>친화력</span>을
                    좋게 봐주셨습니다.
                  </p>
                  <PairReview />
                </div>
              </div>
              <div class="card-resume-detail-item">
                <div class="card-text card-period">이것만은 자신있다!</div>
                <div class="card-body">
                  <h4 class="card-title">1. JavaScript Event 구현</h4>
                  <p class="card-text description">
                    웹의 매력은 바로 사용자로부터 출발한다는 점인 것 같습니다.
                    그 중에서도 신기한 &nbsp;
                    <span>UX 구현</span>에 관심이 있습니다.
                    <br />
                    * 최근 프로젝트에서 드래그 앤 드랍을 VanillaJS로 구현
                    <br />* 서울 지도에 zoom & wheel 이벤트를 구현
                  </p>
                  <h4 class="card-title">2. 주요 스킬셋 </h4>
                  <p class="card-text description">
                    C언어를 프로그래밍 시작 언어로 배워, 다른 스택에 대한 학습 속도가 빠르고
                    잘 적응할 자신 있습니다.
                    <br />
                    <span>프론트엔드</span> React, Nuxt
                    <br />
                    <span>백엔드</span> Node.js, Express, MySQL, ElasticSearch,
                    AWS deploy
                    <br />
                    <span>기타 언어</span>
                    C, python
                  </p>
                </div>
              </div>
            </div>
          </article>
          <article class="card-resume-item">
            <div class="section-title">
              <span>교육</span>
            </div>

            <div class="section-items-group">
              <div class="card-resume-detail-item">
                <div class="card-text card-period">2017-03 ~ 2021-02</div>
                <div class="card-body">
                  <h4 class="card-title">한양대학교</h4>
                  <h5 class="card-text">융합전자공학부</h5>
                  <p class="card-text description">
                    [직군 관련 이수 과목]
                    <br />
                    <span>C언어</span>
                    자료 구조론, 알고리즘, 컴퓨터 네트워크
                    <br />
                    <span>Python</span>
                    공학도를 위한 창의적 컴퓨팅, 공학도를 위한 창의적
                    프로그래밍, 선형대수, 인공지능개론
                    <br />
                    <span>신호처리</span>
                    디지털 논리설계, 확률 통계론, 수치해석 (MATLAB), 랜덤
                    프로세스
                  </p>
                </div>
              </div>
              <div class="card-resume-detail-item">
                <div class="card-text card-period">2020-10 ~ 2021-02</div>
                <div class="card-body">
                  <h4 class="card-title">코드스테이츠</h4>
                  <h5 class="card-text">SW Engineer BootCamp Immersive 25th</h5>
                  <p class="card-text description">
                    [커리큘럼] JS 기반 웹개발 풀스택 과정 학습
                    <br />
                    <span>프론트엔드</span>
                    HTML/CSS/JS 기초 학습 후 React, Redux를 이용한 SPA 개발
                    <br />
                    <span>백엔드</span>
                    Node.js, Express 를 이용한 RESTful API 설계, SQL, ORM
                    (sequelize), 로그인과 인증
                    <br />
                    <span>배포 및 환경</span>
                    Linux CLI, AWS (https : CloudFront(clinet), EC2(back) 등)
                    <br />
                    <span>협업 능력</span>
                    GIT, 페어 프로그래밍(매 수업 짝꿍과 진행)
                  </p>
                </div>
              </div>
              <div class="card-resume-detail-item">
                <div class="card-text card-period">2020-07 ~ 2020-09</div>
                <div class="card-body">
                  <h4 class="card-title">
                    [Coursera] deeplearning.ai 강의 수강
                  </h4>
                  <h5 class="card-text">딥러닝 개념 공부 후 졸업작품 진행</h5>
                  <p class="card-text description">
                    [강의 목록]
                    <br />
                    <span>course1</span>
                    Neural Networks and Deep Learning
                    <br />
                    <span>course2</span>
                    Improving Deep Neural Networks - Hyperparameter tuning,
                    Regularization and Optimization
                    <br />
                    <span>course3</span>
                    Structuring Machine Learning Projects
                    <br />
                    <span>course4</span>
                    Convolutional Neural Networks
                  </p>
                </div>
              </div>
            </div>
          </article>
          <article class="card-resume-item">
            <div class="section-title">
              <span>수상 이력</span>
            </div>

            <div class="section-items-group">
              <div class="card-resume-detail-item">
                <div class="card-text card-period">2019-12</div>
                <div class="card-body">
                  <h4 class="card-title">한이음 엑스포 2019 동상</h4>
                  <h5 class="card-text">전자가격표시기 </h5>
                  <img src={awards_2019_dice} style={{ width: "90%" }} />
                </div>
              </div>
              <div class="card-resume-detail-item">
                <div class="card-text card-period">2018-12</div>
                <div class="card-body">
                  <h4 class="card-title">한이음 엑스포 2018 입상</h4>
                  <h5 class="card-text">전자게시판 관리 웹 페이지 </h5>
                  <img src={awards_2018_dachshund} style={{ width: "90%" }} />
                </div>
              </div>
            </div>
          </article>
          <article class="card-resume-item">
            <div class="section-title">
              <span>활동</span>
            </div>

            <div class="section-items-group">
              <div class="card-resume-detail-item">
                <div class="card-text card-period">2018-03 ~ 2018-06</div>
                <div class="card-body">
                  <h4 class="card-title">
                    [Microsoft-JA Korea] Be a Coding Hero 6기
                  </h4>
                  <h5 class="card-text">
                    micro:bit 과 블록코딩을 이용한 실습 지도
                  </h5>
                  <img src={activity_coding_hero} style={{ width: "90%" }} />
                </div>
              </div>
              <div class="card-resume-detail-item">
                <div class="card-text card-period">2019 ~ </div>
                <div class="card-body">
                  <h4 class="card-title">전공 관련 유튜브 콘텐츠 제작</h4>
                  <h5>
                    <a href="https://youtu.be/irUOp0czNQg">
                      유튜브 링크 (클릭)
                    </a>
                  </h5>

                  <img
                    src={activity_youtube_thumbnail}
                    style={{ width: "90%" }}
                  />
                </div>
              </div>
            </div>
          </article>
        </div>
      </section>
    );
  }
}

export default About;
